import { render, staticRenderFns } from "./EventByCategory.vue?vue&type=template&id=304362cd"
import script from "./EventByCategory.vue?vue&type=script&lang=js"
export * from "./EventByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports